import { DateTime } from 'luxon';
import { OffsetDateTime } from 'src/app/generated/common/date_time/date_time';

export class LuxonDateTimeHelpers {
  static  offsetDateTimeToLocalString(date: OffsetDateTime, format: string) {
    return DateTime
      .fromISO(date.isoDate || '', { zone: 'utc' })
      .setZone(date.offset)
      .toFormat(format);
  }
}
